import { render, staticRenderFns } from "./FlightsListItem.vue?vue&type=template&id=7b625a2d&scoped=true"
import script from "./FlightsListItem.vue?vue&type=script&lang=js"
export * from "./FlightsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b625a2d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsListItemLeg: require('/home/forge/ab.farescraper.com/components/FlightsListItemLeg.vue').default,Dropdown: require('/home/forge/ab.farescraper.com/components/Dropdown.vue').default,IconsPhone: require('/home/forge/ab.farescraper.com/components/IconsPhone.vue').default})
